import { __decorate, __metadata, __param } from "tslib";
import { ViewParameterList } from './ViewParameterList';
import { injectable, inject } from 'inversify';
import { NeoReactTypes } from '../Modules/Types';
import { RoutingState } from './RoutingState';
var NavigationHelper = /** @class */ (function () {
    function NavigationHelper(routingState) {
        this.routingState = routingState;
    }
    NavigationHelper.prototype.navigateInternal = function (url, replace) {
        if (replace === void 0) { replace = false; }
        if (replace) {
            this.currentRouteProps.history.replace(url);
        }
        else {
            this.currentRouteProps.history.push(url);
        }
    };
    NavigationHelper.prototype.navigateToView = function (view, paramValues) {
        this.navigateInternal(this.getPathForView(view, paramValues));
    };
    NavigationHelper.prototype.getPathForView = function (view, paramValues) {
        var basePath = this.routingState.appRouteProvider.getPathForComponent(view);
        if (basePath) {
            if (paramValues) {
                return ViewParameterList.getPathForValues(basePath, view.params, paramValues);
            }
            else {
                return basePath;
            }
        }
        else {
            throw Error("Cannot find route for component " + view.name);
        }
    };
    NavigationHelper.prototype.getCurrentViewPath = function () {
        var basePath = this.currentRouteProps.match.path;
        var paramIndex = basePath.indexOf(":");
        if (paramIndex > 0) {
            basePath = basePath.substring(0, paramIndex);
            if (basePath.endsWith("/")) {
                basePath = basePath.substring(0, basePath.length - 1);
            }
        }
        return basePath;
    };
    Object.defineProperty(NavigationHelper.prototype, "currentRouteProps", {
        get: function () {
            return this.routingState.currentRouteProps;
        },
        enumerable: false,
        configurable: true
    });
    NavigationHelper = __decorate([
        injectable(),
        __param(0, inject(NeoReactTypes.Routing.GlobalRoutingState.symbol)),
        __metadata("design:paramtypes", [RoutingState])
    ], NavigationHelper);
    return NavigationHelper;
}());
export default NavigationHelper;
